import { PRODUCTS } from '../enums/'

export const DOCUMENT_PRODUCT_PATH = {
  [PRODUCTS.AUTO]: 'auto',
  [PRODUCTS.HOME]: 'home',
}
